import styled from 'styled-components';
import colors from 'styles/colors';
// import media from 'styles/media';
import fonts from 'styles/fonts';
import PillButton from 'components/buttons/PillButton';

export const Title = styled.h2`
  display: inline-block;
  color: ${colors.secondary.deepCove};
  font-family: ${fonts.primary.regular};
  font-size: 14px;
  line-height: 17px;
  letter-spacing: 1px;
  margin: 0;
  padding: 0 0 3px;
  width: auto;
  border-bottom: ${colors.secondary.deepCove} solid 1.5px;
  margin-bottom: 28px;
`;

export const ButtonWrap = styled.div`
  display: inline-block;
  &.disabled {
    opacity: 0.25;
    pointer-events: none;
  }
`;

export const Button = styled(PillButton)``;

export const Section = styled.div``;

export const PortOptions = styled.div`
  display: flex;
  gap: ${({ gap }) => gap};
  flex-wrap: wrap;
`;
